/** One export run to Hesabfa and what it did. */
export interface HesabfaExport {
  id: string;
  from: string;
  to: string;
  status: 'Queued' | 'Running' | 'Done' | 'Failed';
  created_by?: string;
  settlements: number;
  invoices_created: number;
  payments_created: number;
  contacts_created: number;
  already_exported: number;
  skipped: number;
  failed: number;
  issues: { settlement_id: string; error: string }[];
  error?: string;
  created_at: string;
  started_at?: string;
  finished_at?: string;
}

export type ComparisonIssue =
  | 'not_in_hesabfa' | 'not_in_bot' | 'amount' | 'coins' | 'contact' | 'date' | 'no_source'
  | 'payment_missing' | 'payment_amount' | 'payment_source' | 'payment_fee' | 'payment_unlinked'
  | 'source_unresolved';

export interface ComparisonSettlement {
  id: string;
  kind: string;
  supplier_name: string;
  paid_at: string;
  amount_rial: number;
  source_account_id?: string;
}

export interface ComparisonPayment {
  number: number;
  day: string;
  source: string;
  source_kind: string;
  source_code: string;
  amount_rial: number;
  fee_rial: number;
  linked: boolean;
}

export interface ComparisonRow {
  /** reference: sent by the bot · guess / group: entered by hand · none: one side only. */
  match: 'reference' | 'guess' | 'group' | 'none';
  issues: ComparisonIssue[];
  bot?: {
    settlements: ComparisonSettlement[];
    day: string;
    contact: string;
    amount_rial: number;
    coins: number;
    source?: string;
    source_kind?: string;
    source_code?: string;
    /** Booked to the unspecified account, for the accountant to move. */
    source_unspecified: boolean;
    fee_rial: number;
  };
  hesabfa?: {
    invoice_number: string;
    reference?: string;
    day: string;
    contact: string;
    contact_code: string;
    amount_rial: number;
    coins: number;
    paid_rial: number;
    payments: ComparisonPayment[];
  };
}

export interface HesabfaComparison {
  from: string;
  to: string;
  counts: Record<string, number>;
  rows: ComparisonRow[];
}

export const ISSUE_LABELS: Record<ComparisonIssue, string> = {
  not_in_hesabfa: 'Not in Hesabfa',
  not_in_bot: 'Not in the bot',
  amount: 'Amount differs',
  coins: 'Coins differ',
  contact: 'Different payee',
  date: 'Different day',
  no_source: 'Paid-from not recorded',
  payment_missing: 'No payment in Hesabfa',
  payment_amount: 'Payment amount differs',
  payment_source: 'Paid from another account',
  payment_fee: 'Fee differs',
  payment_unlinked: 'Payment not linked to invoice',
  source_unresolved: 'Awaiting accountant (unspecified account)',
};

export const MATCH_LABELS: Record<ComparisonRow['match'], string> = {
  reference: 'Sent by the bot',
  guess: 'Entered by hand',
  group: 'Entered by hand (merged)',
  none: 'One side only',
};
